import getState from './getState';
import getFont from './getFont';
import style from './ToolStyle';

export { getState, getFont, style };
